<template>
  <section class="home-merit-container">
    <h2 class="home-title">서베이지만의 장점</h2>

    <ol class="merit-list">
      <li class="merit-item" v-for="(text, idx) in meritList" :key="idx">
        <span class="merit-num">{{ idx + 1 }}</span>
        <span class="merit-text">{{ text }}</span>
      </li>
    </ol>
  </section>
</template>

<script>
export default {
  name: 'HomeMerit',

  data() {
    return {
      meritList: [
        '평균 1~2일 내에 100개의 응답을 수집할 수 있어요',
        '타 설문 서비스 대비 20% 이상 저렴해요',
        '설문 견적을 쉽게 확인하고, 논스톱으로 3분 안에 주문할 수 있어요',
        '두 개 이상의 설문 조사를 진행할 경우, 중복 응답자 없이 응답 수집이 가능해요',
        '설문 응답자에게 따로 리워드를 보상할 필요 없어요'
      ]
    }
  }
}
</script>

<style scoped>
.home-merit-container {
  width: 100%;
  box-sizing: border-box;
  padding: 80px 24px;
  font-family: var(--font-sans);
}

.home-title {
  margin: 0 0 var(--space-6) 0;
  font-size: 34px;
  font-weight: var(--font-weight-bold);
  color: var(--text-heading);
  text-align: left;
}

.merit-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
  max-width: 800px;
}

.merit-item {
  display: flex;
  align-items: center;
  gap: var(--space-4);
  text-align: left;
}

.merit-num {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: var(--green-500);
  color: var(--white);
  font-size: 13px;
  font-weight: var(--font-weight-semibold);
}

.merit-text {
  font-size: 16px;
  color: var(--text-body);
}

@media (max-width: 560px) {
  .home-title {
    font-size: 24px;
  }

  .merit-text {
    font-size: 14px;
  }
}
</style>
